// 运转管理部分路由
export default [{
  path: 'equipmentOperation',
  name: 'equipmentOperation',
  component: function component() {
    return import('@/views/equipmentOperation/index');
  }
}, {
  path: 'equipmentOperationDetail',
  name: 'equipmentOperationDetail',
  component: function component() {
    return import('@/views/equipmentOperation/detail');
  }
}, {
  path: 'fuelDetail',
  name: 'fuelDetail',
  component: function component() {
    return import('@/views/equipmentOperation/fuelDetail');
  }
}, {
  path: 'signDetail',
  name: 'signDetail',
  component: function component() {
    return import('@/views/equipmentOperation/signDetail');
  }
}, {
  path: 'trajectoryMap',
  name: 'trajectoryMap',
  component: function component() {
    return import('@/views/equipmentOperation/base/trajectoryMap');
  }
}];